// field, block, section, package, check, form
export const dynamicLocalizationSections = {
  SECTION: "section",
  BLOCK: "block",
  FIELD: "field",
  PACKAGE: "package",
  CHECK: "check",
  FORM: "form",
  GROUP: "group",
  WORKFLOW: "workflow",
  RISK: "risk",
  OPTION: 'option'
}

export const caseEntityTypesMap = {
  ...dynamicLocalizationSections,
  SEARCH_ENGINE_TOOL: 'components.tools.search_engine'
}

export const replacements = [
  [' ', '&#'],
  ['.', '&%']
];